module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form container"
  }, [_c('div', {
    staticClass: "form-article formResponsive formHorizontal"
  }, [_c('div', {
    staticClass: "form-article-item form-article-item-reviewers"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reviews[0].user_id),
      expression: "reviews[0].user_id"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.reviews[0], "user_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.reviews[0].text = '';
        (_vm.reviews[0].approved = false), (_vm.reviews[0].corrections = false);
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": "0"
    }
  }, [_vm._v("Choose a Reviewer")]), _vm._v(" "), _vm._l((_vm.reviewers), function(user) {
    return _c('option', {
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n          " + _vm._s(user.username) + "\n        ")])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reviews[1].user_id),
      expression: "reviews[1].user_id"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.reviews[1], "user_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.reviews[1].text = '';
        (_vm.reviews[1].approved = false), (_vm.reviews[1].corrections = false);
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": "0"
    }
  }, [_vm._v("Choose a Reviewer")]), _vm._v(" "), _vm._l((_vm.reviewers), function(user) {
    return _c('option', {
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n          " + _vm._s(user.username) + "\n        ")])
  })], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b4656a7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReviewersForm.vue
// module id = 166
// module chunks = 2